import { declareString } from "@1js/localization";

export const RemoveFromWorkgroupTitle = declareString(
  "promptLibrary.removeFromWorkgroupTitle",
  {
    text: "Remove from team",
    comment: "Dialog title to remove prompt from a workgroup.",
  }
);

export const RemoveFromWorkgroupMessage = declareString(
  "promptLibrary.removeFromWorkgroupMessage",
  {
    text: "People in this team won't be able to see or use this prompt anymore.",
    comment: "Message to remove prompt from a workgroup",
  }
);

export const RemoveFromWorkgroupRemoveButtonLabel = declareString(
  "promptLibrary.removeFromWorkgroupRemoveButtonLabel",
  {
    text: "Remove",
    comment: "Button label to cancel a prompt from a group.",
  }
);

export const RemoveFromWorkgroupCancelButtonLabel = declareString(
  "promptLibrary.removeFromWorkgroupCancelButtonLabel",
  {
    text: "Cancel",
    comment: "Button label to cancel a prompt from a group.",
  }
);
